import React, { useRef } from "react";

import { Helmet } from "react-helmet";

import Navbar from "../components/Navbar";
import Banner from "../components/Banner";
import Features from "../components/Features";
import Pricing from "../components/Pricing";
import Footer from "../components/Footer";
import "./Home.css";

const Home = () => {
  const pricingRef = useRef(null);

  return (
    <div className="home-container">
      <Helmet>
        <title>Coin Basis: Home</title>
        <meta property="og:title" content="Coin Basis: Home" />
        {/* Google Analytics */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-1T6SHZQ9X8"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-1T6SHZQ9X8');
          `}
        </script>
        {/* Google Tag Manager */}
        <script>
          {`
            (function(w,d,s,l,i){
              w[l]=w[l]||[];
              w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],
                  j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;
              j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-MTZT7D3V');
          `}
        </script>
        {/* End Google Tag Manager */}
      </Helmet>
      <Navbar />
      <Banner />
      <Features pricingRef={pricingRef} />
      <Pricing ref={pricingRef} />
      <Footer />
    </div>
  );
};

export default Home;
